import merge from 'lodash/merge';

export default (...messages) => ({
    locale: 'pt',
    messages: merge(...messages),
});
